import axios from 'axios'

const URL = `https://api.openweathermap.org/data/2.5/weather`
const API_KEY = '113a8c0bc968f90c14e8ba362fbed8b8'

const FetchWeather = async (query) => {
  const { data } = await axios.get(URL, {
    params: {
      q: query,
      units: 'metric',
      APPID: API_KEY,
    },
  })

  return data
}

export default FetchWeather
